import { useNavigate } from 'react-router';
import { ExLink } from '@boomi/exosphere';
import { MagnifyingGlass } from '@phosphor-icons/react';
import styles from './NotFound.module.css';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.container}>
            <MagnifyingGlass size={40} weight="thin" />
            <h1 className={`${styles.code} ex-text-h1`}>404</h1>
            <p className={styles.message}>This page doesn't exist.</p>
            <ExLink data-pendo-link="notfound-gohome" onClick={() => navigate('/home')}>
                Go to Home
            </ExLink>
        </div>
    );
};

export default NotFound;
